export default "__VITE_ASSET__2VoAHJmh__"